export const guides = [
  {
    slug: 'presale-deposit-return',
    title: '预售定金不退？网购预付款的 7 个常见套路',
    category: 'online',
    summary: '付了定金才发现尾款比平时还贵，「定金」和「订金」一字之差退法完全不同。这份清单帮你把预付款的坑提前标出来。',
    cover: 'https://readdy.ai/api/search-image?query=Warm%20editorial%20flat%20lay%20of%20brown%20cardboard%20parcel%20boxes%20and%20receipts%20on%20a%20cream%20paper%20desk%2C%20soft%20natural%20light%2C%20minimal%20top%20view%2C%20muted%20amber%20and%20beige%20tones%2C%20clean%20product%20photography&width=800&height=600&seq=guide-online-presale&orientation=landscape',
    risk: 'high',
    readTime: '6 分钟',
    date: '2026-08-28',
    tags: ['预售', '定金', '促销'],
    views: '3.2万',
    hot: true,
  },
  {
    slug: 'bigpromo-coupon-traps',
    title: '大促叠券看不懂？满减与优惠规则的避雷清单',
    category: 'online',
    summary: '「先涨后降」「券不能叠加」几乎成了大促固定节目。学会看历史价和到手价，比抢券更省钱。',
    cover: 'https://readdy.ai/api/search-image?query=Stack%20of%20orange%20discount%20coupon%20cards%20and%20a%20small%20calculator%20on%20a%20warm%20cream%20desk%2C%20soft%20daylight%2C%20minimal%20editorial%20flat%20lay%2C%20muted%20amber%20tones%2C%20clean%20composition&width=800&height=600&seq=guide-online-coupon&orientation=landscape',
    risk: 'mid',
    readTime: '5 分钟',
    date: '2026-08-20',
    tags: ['大促', '满减', '比价'],
    views: '2.7万',
    hot: true,
  },
  {
    slug: 'skincare-marketing-words',
    title: '成分表靠前就敢吹？护肤营销话术逐条拆解',
    category: 'beauty',
    summary: '「一瓶抵十瓶」「医院同款」这类说法最经不起推敲。认清成分浓度、肤感和功效之间的关系，少交智商税。',
    cover: 'https://readdy.ai/api/search-image?query=Minimal%20skincare%20dropper%20bottle%20and%20cosmetic%20tube%20on%20a%20cream%20stone%20surface%2C%20soft%20warm%20lighting%2C%20beige%20and%20dusty%20rose%20palette%2C%20clean%20editorial%20product%20photography&width=800&height=600&seq=guide-beauty-words&orientation=landscape',
    risk: 'mid',
    readTime: '7 分钟',
    date: '2026-08-15',
    tags: ['护肤', '成分', '营销'],
    views: '2.4万',
    hot: false,
  },
  {
    slug: 'daigou-skincare-signals',
    title: '代购与「水货」护肤品的翻车信号清单',
    category: 'beauty',
    summary: '价格低得离谱、批号对不上、只发小样图，都是危险信号。买之前对照这份清单逐条自查。',
    cover: 'https://readdy.ai/api/search-image?query=Row%20of%20unlabeled%20cosmetic%20bottles%20and%20shipping%20boxes%20on%20a%20warm%20beige%20table%2C%20soft%20window%20light%2C%20minimal%20editorial%20style%2C%20muted%20rose%20and%20cream%20tones&width=800&height=600&seq=guide-beauty-daigou&orientation=landscape',
    risk: 'high',
    readTime: '6 分钟',
    date: '2026-08-09',
    tags: ['代购', '正品', '售后'],
    views: '1.9万',
    hot: false,
  },
  {
    slug: 'tradein-refurbished-new',
    title: '「以旧换新」换回来的可能是翻新机',
    category: 'tech',
    summary: '官方渠道以外，以旧换新的机器来源常常说不清。到手先查激活日期和电池循环，比看包装更靠谱。',
    cover: 'https://readdy.ai/api/search-image?query=Smartphone%20and%20smartwatch%20beside%20a%20laptop%20on%20a%20dark%20walnut%20desk%2C%20warm%20soft%20light%2C%20minimal%20editorial%20product%20photography%2C%20muted%20amber%20and%20charcoal%20tones&width=800&height=600&seq=guide-tech-tradein&orientation=landscape',
    risk: 'high',
    readTime: '8 分钟',
    date: '2026-08-02',
    tags: ['数码', '以旧换新', '验机'],
    views: '2.1万',
    hot: true,
  },
  {
    slug: 'extended-warranty-value',
    title: '家电延保到底值不值？先看清这几点',
    category: 'tech',
    summary: '延保不是不能买，但要看清免责范围、上门费和「只换不修」的真实门槛。别为用不上的服务多花钱。',
    cover: 'https://readdy.ai/api/search-image?query=Home%20appliance%20warranty%20card%20and%20small%20kitchen%20device%20on%20a%20cream%20counter%2C%20soft%20warm%20lighting%2C%20minimal%20editorial%20flat%20lay%2C%20beige%20and%20muted%20orange%20tones&width=800&height=600&seq=guide-tech-warranty&orientation=landscape',
    risk: 'low',
    readTime: '5 分钟',
    date: '2026-07-26',
    tags: ['家电', '延保', '售后'],
    views: '1.4万',
    hot: false,
  },
  {
    slug: 'livestream-scraps',
    title: '直播间卖的「边角料」到底是什么',
    category: 'food',
    summary: '「工厂直发」「临期特价」听着诱人，但配料和保质期往往被一笔带过。看懂规格与生产信息，才能安心下单。',
    cover: 'https://readdy.ai/api/search-image?query=Packaged%20snacks%20and%20a%20phone%20on%20a%20small%20tripod%20on%20a%20warm%20wooden%20table%2C%20soft%20kitchen%20light%2C%20minimal%20editorial%20flat%20lay%2C%20beige%20and%20amber%20tones&width=800&height=600&seq=guide-food-livestream&orientation=landscape',
    risk: 'mid',
    readTime: '6 分钟',
    date: '2026-07-19',
    tags: ['直播', '食品', '配料'],
    views: '1.7万',
    hot: false,
  },
  {
    slug: 'near-expiry-food',
    title: '临期食品怎么挑才不吃亏',
    category: 'food',
    summary: '临期不等于过期，但不同品类的「安全窗口」差别很大。这份清单告诉你哪些能捡漏，哪些别冒险。',
    cover: 'https://readdy.ai/api/search-image?query=Assorted%20canned%20and%20packaged%20groceries%20on%20a%20cream%20shelf%2C%20date%20labels%20visible%2C%20soft%20daylight%2C%20minimal%20editorial%20style%2C%20warm%20beige%20and%20sage%20tones&width=800&height=600&seq=guide-food-expiry&orientation=landscape',
    risk: 'low',
    readTime: '4 分钟',
    date: '2026-07-12',
    tags: ['临期', '保质期', '囤货'],
    views: '1.1万',
    hot: false,
  },
  {
    slug: 'cheap-ticket-fees',
    title: '低价机票背后的行李费与改签费',
    category: 'travel',
    summary: '票面价最低不等于总价最低。把行李额、退改规则、中转时间算进去，才知道这张票到底值不值。',
    cover: 'https://readdy.ai/api/search-image?query=Boarding%20pass%2C%20passport%20holder%20and%20compact%20suitcase%20on%20a%20warm%20cream%20surface%2C%20soft%20morning%20light%2C%20minimal%20editorial%20flat%20lay%2C%20beige%20and%20amber%20tones&width=800&height=600&seq=guide-travel-ticket&orientation=landscape',
    risk: 'mid',
    readTime: '6 分钟',
    date: '2026-07-05',
    tags: ['机票', '退改', '行李'],
    views: '1.6万',
    hot: true,
  },
  {
    slug: 'homestay-photo-tricks',
    title: '民宿「照骗」识别指南',
    category: 'travel',
    summary: '广角拉大空间、样张代替实拍、定位含糊，是照骗三大特征。订房前用地图和真实评价交叉验证。',
    cover: 'https://readdy.ai/api/search-image?query=Cozy%20minimal%20guest%20room%20with%20linen%20bed%20and%20warm%20lamp%20light%2C%20beige%20and%20terracotta%20palette%2C%20clean%20editorial%20interior%20photography&width=800&height=600&seq=guide-travel-homestay&orientation=landscape',
    risk: 'mid',
    readTime: '5 分钟',
    date: '2026-06-28',
    tags: ['民宿', '订房', '评价'],
    views: '1.3万',
    hot: false,
  },
  {
    slug: 'guaranteed-pass-contract',
    title: '「保过班」的合同里到底藏着什么',
    category: 'edu',
    summary: '保过承诺往往附带严苛的出勤与考试条件，退费条款更是一环扣一环。报名前先逐条读完再签。',
    cover: 'https://readdy.ai/api/search-image?query=Open%20contract%20booklet%20with%20a%20pen%20and%20coffee%20cup%20on%20a%20warm%20wooden%20desk%2C%20soft%20side%20light%2C%20minimal%20editorial%20photography%2C%20beige%20and%20deep%20green%20tones&width=800&height=600&seq=guide-edu-contract&orientation=landscape',
    risk: 'high',
    readTime: '7 分钟',
    date: '2026-06-21',
    tags: ['培训', '合同', '退费'],
    views: '1.5万',
    hot: false,
  },
  {
    slug: 'repair-price-double',
    title: '上门维修报价翻倍的常见手法',
    category: 'home',
    summary: '先报低价再不断加项、拿「原厂配件」当溢价理由，是上门维修最典型的两招。叫师傅前先问清三件事。',
    cover: 'https://readdy.ai/api/search-image?query=Toolbox%2C%20screwdriver%20set%20and%20small%20electronic%20parts%20on%20a%20cream%20workbench%2C%20soft%20workshop%20light%2C%20minimal%20editorial%20flat%20lay%2C%20amber%20and%20charcoal%20tones&width=800&height=600&seq=guide-home-repair&orientation=landscape',
    risk: 'high',
    readTime: '6 分钟',
    date: '2026-06-14',
    tags: ['维修', '报价', '配件'],
    views: '1.8万',
    hot: false,
  },
];